export default __webpack_public_path__ + "static/media/review-img-3.fe13922f.png";